

module.exports = __webpack_require__.stylable.create(
    "Content373167993",
    {"classes":{"root":"Content373167993__root"},"vars":{},"stVars":{},"keyframes":{}},
    ".Content373167993__root{padding:24px 30px 30px}.Content373167993__root.Content373167993---size-6-medium{padding:30px}.Content373167993__root.Content373167993---size-5-large{padding:36px}.Content373167993__root.Content373167993--emptyStateContent{padding:42px}",
    1,
    "Content373167993",
    __webpack_require__.stylable.$
);
